module.exports = __webpack_public_path__ + "img/projects3.e2a127d5.svg";